/**
 * Vendor Rating Service Hooks
 * React hooks for accessing vendor rating management services
 */
import { useCCMS } from '../useCCMS';
/**
 * Hook to access all vendor rating-related services
 * @returns VendorRatingServices object containing all vendor rating service instances
 */
export function useVendorRatingServices() {
    const { services } = useCCMS();
    if (!services?.vendorrating) {
        throw new Error('Vendor rating services not available. Ensure CCMSProvider is configured with vendor rating services.');
    }
    return services.vendorrating;
}
/**
 * Hook to access VendorRatingService
 */
export function useVendorRatingService() {
    return useVendorRatingServices().vendorRating;
}
/**
 * Hook to access VendorRaterTypeService
 */
export function useVendorRaterTypeService() {
    return useVendorRatingServices().vendorRaterType;
}
/**
 * Hook to access VendorFlagTypeService
 */
export function useVendorFlagTypeService() {
    return useVendorRatingServices().vendorFlagType;
}
/**
 * Hook to access VendorFlagStatusService
 */
export function useVendorFlagStatusService() {
    return useVendorRatingServices().vendorFlagStatus;
}
/**
 * Hook to access VendorFlagService
 */
export function useVendorFlagService() {
    return useVendorRatingServices().vendorFlag;
}
/**
 * Hook to access VendorResponseService
 */
export function useVendorResponseService() {
    return useVendorRatingServices().vendorResponse;
}
/**
 * Hook to access VendorRatingShopService
 */
export function useVendorRatingShopService() {
    return useVendorRatingServices().vendorRatingShop;
}
//# sourceMappingURL=useVendorRatingServices.js.map